import { render, staticRenderFns } from "./ss-train-list.vue?vue&type=template&id=60c01d70&scoped=true&"
import script from "./ss-train-list.vue?vue&type=script&lang=js&"
export * from "./ss-train-list.vue?vue&type=script&lang=js&"
import style0 from "./ss-train-list.vue?vue&type=style&index=0&id=60c01d70&lang=scss&scoped=scoped&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60c01d70",
  null
  
)

export default component.exports